import type { Device, DeviceCategory } from "../types";

export const DEVICES: Device[] = [
  // iPhone — 14
  {
    id: "iphone-se-3",
    name: "iPhone SE (3rd)",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 375,
    height: 667,
    pixelRatio: 2,
    notch: "button",
  },
  {
    id: "iphone-8-plus",
    name: "iPhone 8 Plus",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 414,
    height: 736,
    pixelRatio: 3,
    notch: "button",
  },
  {
    id: "iphone-13-mini",
    name: "iPhone 13 mini",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 375,
    height: 812,
    pixelRatio: 3,
    notch: "notch",
  },
  {
    id: "iphone-11",
    name: "iPhone 11",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 414,
    height: 896,
    pixelRatio: 2,
    notch: "notch",
  },
  {
    id: "iphone-13",
    name: "iPhone 13",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 390,
    height: 844,
    pixelRatio: 3,
    notch: "notch",
  },
  {
    id: "iphone-14",
    name: "iPhone 14",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 390,
    height: 844,
    pixelRatio: 3,
    notch: "notch",
  },
  {
    id: "iphone-14-plus",
    name: "iPhone 14 Plus",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 428,
    height: 926,
    pixelRatio: 3,
    notch: "notch",
  },
  {
    id: "iphone-15",
    name: "iPhone 15",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 393,
    height: 852,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-15-pro",
    name: "iPhone 15 Pro",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 393,
    height: 852,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-15-pro-max",
    name: "iPhone 15 Pro Max",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 430,
    height: 932,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-16",
    name: "iPhone 16",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 393,
    height: 852,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-16-plus",
    name: "iPhone 16 Plus",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 430,
    height: 932,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-16-pro",
    name: "iPhone 16 Pro",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 402,
    height: 874,
    pixelRatio: 3,
    notch: "island",
  },
  {
    id: "iphone-16-pro-max",
    name: "iPhone 16 Pro Max",
    brand: "Apple",
    category: "iphone",
    os: "ios",
    width: 440,
    height: 956,
    pixelRatio: 3,
    notch: "island",
  },

  // iPad — 8
  {
    id: "ipad-mini-7",
    name: "iPad mini 7",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 744,
    height: 1133,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-9",
    name: "iPad (9th, 10.2\")",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 810,
    height: 1080,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-10",
    name: "iPad (10th, 10.9\")",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 820,
    height: 1180,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-air-11",
    name: "iPad Air 11\"",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 820,
    height: 1180,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-air-13",
    name: "iPad Air 13\"",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 1024,
    height: 1366,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-pro-11-m4",
    name: "iPad Pro 11\" M4",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 834,
    height: 1210,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-pro-13-m4",
    name: "iPad Pro 13\" M4",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 1032,
    height: 1376,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "ipad-classic",
    name: "iPad (classic 9.7\")",
    brand: "Apple",
    category: "ipad",
    os: "ios",
    width: 768,
    height: 1024,
    pixelRatio: 2,
    notch: "none",
  },

  // Android phones — 20
  {
    id: "galaxy-s25",
    name: "Galaxy S25",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 780,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-s24",
    name: "Galaxy S24",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 780,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-s23",
    name: "Galaxy S23",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 780,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-s25-ultra",
    name: "Galaxy S25 Ultra",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 915,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-s24-ultra",
    name: "Galaxy S24 Ultra",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 384,
    height: 832,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-a15",
    name: "Galaxy A15",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 800,
    pixelRatio: 2.5,
    notch: "punch",
  },
  {
    id: "galaxy-a55",
    name: "Galaxy A55",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 385,
    height: 854,
    pixelRatio: 2.75,
    notch: "punch",
  },
  {
    id: "galaxy-z-flip-6",
    name: "Galaxy Z Flip 6",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 748,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-z-fold-6-folded",
    name: "Galaxy Z Fold 6 (folded)",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 373,
    height: 748,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "galaxy-z-fold-6-open",
    name: "Galaxy Z Fold 6 (open)",
    brand: "Samsung",
    category: "android-phone",
    os: "android",
    width: 690,
    height: 829,
    pixelRatio: 2.5,
    notch: "punch",
  },
  {
    id: "pixel-9",
    name: "Pixel 9",
    brand: "Google",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 923,
    pixelRatio: 2.625,
    notch: "punch",
  },
  {
    id: "pixel-9-pro",
    name: "Pixel 9 Pro",
    brand: "Google",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 892,
    pixelRatio: 2.625,
    notch: "punch",
  },
  {
    id: "pixel-9-pro-xl",
    name: "Pixel 9 Pro XL",
    brand: "Google",
    category: "android-phone",
    os: "android",
    width: 448,
    height: 998,
    pixelRatio: 2.625,
    notch: "punch",
  },
  {
    id: "pixel-8",
    name: "Pixel 8",
    brand: "Google",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 915,
    pixelRatio: 2.625,
    notch: "punch",
  },
  {
    id: "pixel-8a",
    name: "Pixel 8a",
    brand: "Google",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 915,
    pixelRatio: 2.625,
    notch: "punch",
  },
  {
    id: "oneplus-13",
    name: "OnePlus 13",
    brand: "OnePlus",
    category: "android-phone",
    os: "android",
    width: 412,
    height: 919,
    pixelRatio: 3,
    notch: "punch",
  },
  {
    id: "xiaomi-14",
    name: "Xiaomi 14",
    brand: "Xiaomi",
    category: "android-phone",
    os: "android",
    width: 393,
    height: 873,
    pixelRatio: 2.75,
    notch: "punch",
  },
  {
    id: "redmi-note-13",
    name: "Redmi Note 13",
    brand: "Xiaomi",
    category: "android-phone",
    os: "android",
    width: 393,
    height: 873,
    pixelRatio: 2.75,
    notch: "punch",
  },
  {
    id: "android-360-640",
    name: "Android compact",
    brand: "Generic",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 640,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "android-360-740",
    name: "Android common",
    brand: "Generic",
    category: "android-phone",
    os: "android",
    width: 360,
    height: 740,
    pixelRatio: 2.5,
    notch: "punch",
  },

  // Android tablets — 8
  {
    id: "galaxy-tab-s9",
    name: "Galaxy Tab S9",
    brand: "Samsung",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1280,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "galaxy-tab-s9-plus",
    name: "Galaxy Tab S9+",
    brand: "Samsung",
    category: "android-tablet",
    os: "android",
    width: 876,
    height: 1400,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "galaxy-tab-s9-ultra",
    name: "Galaxy Tab S9 Ultra",
    brand: "Samsung",
    category: "android-tablet",
    os: "android",
    width: 920,
    height: 1472,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "galaxy-tab-a9",
    name: "Galaxy Tab A9+",
    brand: "Samsung",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1340,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "pixel-tablet",
    name: "Pixel Tablet",
    brand: "Google",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1280,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "fire-hd-10",
    name: "Fire HD 10",
    brand: "Amazon",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1280,
    pixelRatio: 1.5,
    notch: "none",
  },
  {
    id: "xiaomi-pad-6",
    name: "Xiaomi Pad 6",
    brand: "Xiaomi",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1280,
    pixelRatio: 2,
    notch: "none",
  },
  {
    id: "oneplus-pad",
    name: "OnePlus Pad",
    brand: "OnePlus",
    category: "android-tablet",
    os: "android",
    width: 800,
    height: 1400,
    pixelRatio: 2.4,
    notch: "none",
  },
];

export const DEFAULT_DEVICE_IDS = [
  "iphone-se-3",
  "iphone-13",
  "iphone-16-pro",
  "iphone-16-pro-max",
  "ipad-10",
  "ipad-pro-11-m4",
  "galaxy-s25",
  "galaxy-s25-ultra",
  "pixel-9",
  "pixel-9-pro-xl",
  "galaxy-tab-s9",
  "android-360-740",
];

export const CATEGORY_LABELS: Record<DeviceCategory, string> = {
  iphone: "iPhone",
  ipad: "iPad",
  "android-phone": "Android",
  "android-tablet": "Tablets",
};

export function getDevice(id: string): Device | undefined {
  return DEVICES.find((d) => d.id === id);
}

export function devicesByCategory(category: DeviceCategory | "all"): Device[] {
  if (category === "all") return DEVICES;
  return DEVICES.filter((d) => d.category === category);
}

export const DEVICE_COUNT = DEVICES.length;
